$(document).ready(function () {
    const ajaxPath = '/action/department';
    let ajaxLockActive = false;
    let debounceTimer;

    activateTagsChosenPlugin();

    $(document).on('click', '#departments_list_panel .department_item', function () {
        if (ajaxLockActive) {
            return false;
        }
        const id = $(this).attr('data-id');
        ajaxLockActive = true;
        showPreloader();
        $.ajax({
            type: 'GET',
            url: `${ajaxPath}/${id}`,
            dataType: 'json'
        }).success(function (data) {
            $('#department_form', document).html(data.html);
            activateTagsChosenPlugin();
        }).error(function (data) {
            showErrors(window.t('departmentGetError'), data, '#department_wrapper');
        }).always(function () {
            hidePreloader();
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', '#department_wrapper #department_btn_create', function () {
        if (ajaxLockActive) {
            return false;
        }
        const formData = collectFormData();
        ajaxLockActive = true;
        showPreloader();
        $.ajax({
            type: 'POST',
            url: ajaxPath,
            data: formData
        }).success(function () {
            window.location.reload();
        }).error(function (data) {
            hidePreloader();
            showErrors(window.t('departmentCreateError'), data, '#department_wrapper');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', '#department_wrapper #department_btn_update', function () {
        if (ajaxLockActive) {
            return false;
        }
        const formData = collectFormData();
        ajaxLockActive = true;
        showPreloader();
        $.ajax({
            type: 'POST',
            url: `${ajaxPath}/${formData['id']}`,
            data: formData
        }).success(function () {
            window.location.reload();
        }).error(function (data) {
            hidePreloader();
            showErrors(window.t('departmentUpdateError'), data, '#department_wrapper');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', '#department_wrapper #department_btn_delete', function () {
        if (ajaxLockActive) {
            return false;
        }
        const name = $('#department_wrapper #department_name', document).val();
        if (!confirm(`${window.t('departmentDeleteConfirm')} "${name}"?`)) {
            return;
        }
        const id = $('#department_wrapper #department_id', document).val();
        ajaxLockActive = true;
        showPreloader();
        $.ajax({
            type: 'DELETE',
            url: `${ajaxPath}/${id}`
        }).success(function () {
            window.location.reload();
        }).error(function (data) {
            hidePreloader();
            showErrors(window.t('departmentDeleteError'), data, '#department_wrapper');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', '#department_wrapper #departments_search_button', function () {
        if (ajaxLockActive) {
            return false;
        }
        const searchInput = $('#department_wrapper #departments_search_input', document);
        const searchString = searchInput.val();

        ajaxLockActive = false;
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(function () {
            ajaxLockActive = true;
            $.ajax({
                type: 'GET',
                url: ajaxPath,
                data: {
                    search_string: searchString,
                },
                dataType: 'json'
            }).success(function (data) {
                $('#department_wrapper #departments_list', document).html(data.html);
            }).error(function () {
                searchInput.notify(window.t('departmentsSearchError'), {
                    position: "top",
                    className: 'error'
                });
            }).always(function () {
                ajaxLockActive = false;
            });
        }, 300);

        return false;
    });

    function activateTagsChosenPlugin() {
        $("#chosen_department_tags", document).chosen({
            no_results_text: "Ingen tags funnet!",
            width: "100%",
        });
    }

    function collectFormData() {
        const tags = $('#chosen_department_tags', document).val() || [];

        return {
            id: parseInt($('#department_id', document).val(), 10) || null,
            name: $.trim($('#department_name', document).val() || ''),
            tag_ids: tags.map(tag => parseInt(tag, 10)).filter(tag => !isNaN(tag))
        };
    }
});


